export default __webpack_public_path__ + "static/media/image_uno.1901ae45.PNG";